export default {
  opponentRank: {
    title: "Gegner-Rang",
    tabs: {
      byRanking: "Nach Rang",
      allRankings: "Alle Rankings",
    },
    empty: {
      title: "Keine Gegner-Rankings verfügbar",
    },
  },
};
